<template>
  <div>
    <el-card sharow>
      <el-form :model="searchForm" ref="searchForm" size="small" inline>
        <el-form-item label="产品名称" prop="name">
          <el-input v-model.trim="searchForm.name" placeholder="产品名称" />
        </el-form-item>
        <el-form-item label="状态" prop="state">
          <el-select v-model.trim="searchForm.state">
            <el-option :value="1" label="启用"></el-option>
            <el-option :value="2" label="停用"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label=" " label-width="100px">
          <el-button type="primary" @click="search('searchForm')">查询</el-button>
          <el-button @click="reset('searchForm')">重置</el-button>
        </el-form-item>
      </el-form>
      <div>
        <el-button type="primary" @click="add()">添加</el-button>
      </div>
    </el-card>
    <br>
    <el-table border stripe v-loading="loading" :data="tableData" style="width: 100%">
      <el-table-column prop="name" label="活动名称" minWidth="250" align="center"></el-table-column>
      <el-table-column prop="groupNum" label="拼团人数" minWidth="150" align="center"></el-table-column>
      <el-table-column prop="validityHour" label="拼团时效/小时" minWidth="150" align="center"></el-table-column>
      <el-table-column prop="startDate" label="活动有效期" minWidth="200" align="center">
        <template slot-scope="scope">
          <div>{{scope.row.startDate}}</div>
          <div>至</div>
          <div>{{scope.row.endDate}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="virtualInitiate" label="拼团虚拟账户" minWidth="120" align="center">
        <template slot-scope="scope">
          <template v-if="scope.row.virtualInitiate == 1">启用</template>
          <template v-else-if="scope.row.virtualInitiate == 2">停用</template>
          <template v-else>--</template>
        </template>
      </el-table-column>
      <el-table-column prop="fillWithZero" label="补位虚拟账户" minWidth="120" align="center">
        <template slot-scope="scope">
          <template v-if="scope.row.fillWithZero == 1">启用</template>
          <template v-else-if="scope.row.fillWithZero == 2">停用</template>
          <template v-else>--</template>
        </template>
      </el-table-column>
      <el-table-column prop="state" label="状态" minWidth="120" align="center">
        <template slot-scope="scope">
          <template v-if="scope.row.state == 1">启用</template>
          <template v-else-if="scope.row.state == 2">停用</template>
          <template v-else>--</template>
        </template>
      </el-table-column>
      <el-table-column prop="capsuleImg" label="胶囊位" minWidth="120" align="center">
        <template slot-scope="scope">
          <el-image class="img" :src="scope.row.capsuleImg" :preview-src-list="[scope.row.capsuleImg]" />
        </template>
      </el-table-column>
      <el-table-column prop="activityImg" label="活动页图片" minWidth="120" align="center">
        <template slot-scope="scope">
          <el-image class="img" :src="scope.row.activityImg" :preview-src-list="[scope.row.activityImg]" />
        </template>
      </el-table-column>
      <el-table-column prop="alertImg" label="温馨提示" minWidth="120" align="center">
        <template slot-scope="scope">
          <el-image class="img" :src="scope.row.alertImg" :preview-src-list="[scope.row.alertImg]" />
        </template>
      </el-table-column>
      <el-table-column prop="name" minWidth="200" align="center" label="操作" fixed="right">
        <template slot-scope="scope">
          <el-row :gutter="2">
            <el-col :span="12">
              <a v-if="scope.row.state == 2" class="blue_Box" @click="action_fn(1,scope.row)">编辑</a>
              <span v-else-if="scope.row.state == 1" class="gray_Box" @click="after_fn">编辑</span>
            </el-col>
            <el-col :span="12"><a class="blue_Box" @click="action_fn(2,scope.row)">活动范围管理</a></el-col>
            <el-col :span="12"><a class="blue_Box" @click="action_fn(4,scope.row)">{{scope.row.state == 1 ? '停用' : '启用'}}</a></el-col>
            <el-col :span="12"><a class="blue_Box" @click="action_fn(3,scope.row)">班级管理</a></el-col>
          </el-row>
        </template>
      </el-table-column>
    </el-table>
    <br>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="pageSizes" layout="total, sizes, prev, pager, next" :total="total" />
    <!-- 添加工作产品 -->
    <addActProduct ref="addActProduct" />
    <!-- 活动范围 -->
    <ActRange ref="ActRange" />
    <!-- 活动产品管理 -->
    <productAdmin ref="productAdmin" />
    <!-- 编辑活动 -->
    <editeAct ref="editeAct" />
  </div>
</template>

<script>
import tableMoudel from "@/libs/mixin/table";

import addActProduct from "./com/addActProduct.vue"
import ActRange from "./com/ActRange.vue"
import productAdmin from "./com/productAdmin"
import editeAct from "./com/editeAct"

import { Admin } from "./api"

export default {
  mixins: [tableMoudel],
  components: { addActProduct, ActRange, productAdmin, editeAct },
  data () {
    return {
      searchForm: {
        name: null,
        state: null
      }
    }
  },
  created () {
    this.getData()
  },
  mounted () {
    this.$bus.$on('update', res => {
      if (res) {
        this.getData()
      }
    })
  },
  methods: {
    after_fn(){
      this.$message({
        message: '该活动已设置活动范围，请停用后再试。',
        type: 'warning'
      });
    },
    async getData () {
      const params = { ...this.pageInfo, ...this.searchForm }
      const res = await Admin.getListPage(params)
      if (res.code !== 0) return
      const { records } = res.data
      this.tableData = records
      this.total = Number(res.data.total)
    },
    action_fn (type, item) {
      switch (type) {
        case 1:
          this.$refs.editeAct.init(item)
          break;
        case 2:
          this.$refs.ActRange.init(item.id)
          break;
        case 3:
          this.$refs.productAdmin.init(item.id)
          break;
        case 4:
          this.$confirm(`是否将活动状态改为${item.state == 1 ? '停用' : '启用'}?`, `提示`, {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            const params = {
              id: item.id,
              state: item.state == 1 ? 2 : 1
            }
            const res = await Admin.updateActivitySpellGroupState(params)
            if (res.code !== 0) return
            this.$message.success('操作成功！')
            this.$bus.$emit('update', true)
          })
          break;
      }
    },
    add () {
      this.$refs.editeAct.init()
    },
  }
}
</script>

<style scoped>
.img {
  width: 60px;
  height: 60px;
}
.gray_Box{
  color: gray;
  cursor: not-allowed;
}
</style>